import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Container, Card, Button } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { db } from "../firebase/firebase-config";
import { collection, getDocs } from "firebase/firestore/lite";

const NewsAndEvents = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [news, setNews] = useState([]);
  const [newsLoading, setNewsLoading] = useState(false);

  useEffect(() => {
    fetchNews();
  }, []);

  async function fetchNews() {
    try {
      setNewsLoading(true);
      const newsCollectionRef = collection(db, "sacco", "TEKiK01inpRB3NFlK65S", "news");
      const newsSnapshot = await getDocs(newsCollectionRef);
      const fetchedNews = newsSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setNews(fetchedNews);
    } catch (err) {
      console.error("Error fetching news:", err);
    } finally {
      setNewsLoading(false);
    }
  }

  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 3, // Show 3 cards at a time
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: "ease-in-out",
    pauseOnHover: false,
    rtl: true, // Set RTL to true for right-to-left movement
    centerMode: false, // Disable center mode to prevent overlapping
    centerPadding: "0px", // Ensure the card fills the screen
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } }, // 2 cards for medium screens
      { breakpoint: 768, settings: { slidesToShow: 1 } } // 1 card for smaller screens
    ]
  };

  const welcomingCard = {
    title: "Welcome to Metropolitan Hospital Sacco!",
    date: "We are glad to have you with us. Stay tuned for the latest updates.",
    img: "/assets/img-welcome.jpg",
    details: "Check out our latest events and news to stay informed about what's happening at Metropolitan Hospital Sacco."
  };

  return (
    <>
      <Navbar />
      <Container className="py-5 mt-40">
        <h2 className="text-center mb-4 text-4xl font-extrabold bg-gradient-to-r from-blue-500 to-purple-700 text-transparent bg-clip-text drop-shadow-lg">
          Latest News & Events 🚀
        </h2>

        <Card className="p-6 shadow-2xl bg-opacity-20 backdrop-blur-lg bg-white/30 border border-gray-300 rounded-2xl">
          {selectedItem ? (
            <div className="text-center p-5 bg-white rounded-lg shadow-lg max-w-2xl mx-auto">
              <img src={selectedItem.image} alt={selectedItem.name} className="w-full h-[300px] object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{selectedItem.name}</h3>
              <p className="text-gray-700 font-medium text-lg mb-4">{selectedItem.date}</p>
              <pre className="text-gray-600 text-left text-sm md:text-base leading-relaxed whitespace-pre-wrap p-4 bg-gray-100 rounded-lg border border-gray-300">
                {selectedItem.details}
              </pre>
              <Button onClick={() => setSelectedItem(null)} className="mt-4 px-6 py-2 bg-gradient-to-r from-red-500 to-pink-500 text-white font-bold rounded-lg shadow-md hover:from-red-600 hover:to-pink-600 transition-all">
                Close
              </Button>
            </div>
          ) : (
            // If only one news item
            news.length === 1 ? (
              <div className="flex justify-center">
                <div
                  className="w-full max-w-[100%] h-[500px] bg-white bg-opacity-90 rounded-lg shadow-xl text-center p-5 transition-transform transform hover:scale-105 hover:shadow-2xl cursor-pointer border border-gray-200"
                  onClick={() => setSelectedItem(news[0])}
                >
                  <img src={news[0].image} alt={news[0].name} className="w-full h-[60%] object-cover rounded-md mb-4 transition-all duration-300 hover:scale-110 shadow-md" />
                  <h3 className="text-2xl font-semibold text-gray-900 mb-1">{news[0].name}</h3>
                  <p className="text-gray-700 font-medium text-lg mb-2">{news[0].date}</p>
                  <div className="mt-4">
                    <Button
                      onClick={() => setSelectedItem(news[0])}
                      className="px-2 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-bold rounded-lg shadow-md hover:from-blue-600 hover:to-purple-600 transition-all"
                    >
                      Click to View More
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              // If multiple news items, display as slider
              <Slider {...settings}>
                {news.map((item, index) => (
                  <div key={index} className="flex justify-center">
                    <div
                      className="w-[90%] max-w-[350px] h-[350px] bg-white bg-opacity-90 rounded-lg shadow-xl text-center p-5 transition-transform transform hover:scale-105 hover:shadow-2xl cursor-pointer border border-gray-200"
                      onClick={() => setSelectedItem(item)}
                    >
                      <img src={item.image} alt={item.name} className="w-full h-[60%] object-cover rounded-md mb-4 transition-all duration-300 hover:scale-110 shadow-md" />
                      <h3 className="text-2xl font-semibold text-gray-900 mb-1">{item.name}</h3>
                      <p className="text-gray-700 font-medium text-lg mb-2">{item.date}</p>
                      <div className="mt-4">
                        <Button
                          onClick={() => setSelectedItem(item)}
                          className="px-2 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-bold rounded-lg shadow-md hover:from-blue-600 hover:to-purple-600 transition-all"
                        >
                          Click to View More
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            )
          )}
        </Card>
      </Container>
      <Footer />
    </>
  );
};

export default NewsAndEvents;
